import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import EventToAsyncDecorator from '../../../plugins/eventToAsyncDecorator'
import FilterRequest from '../../../Spirit/Common/Extensions/Models/FilterRequest';
import WsResponseModelT from '../../../SchemaBuilderServer/Models/WsResponseModelT';
import GetActiveStatisticResponse from '../../../Spirit/Admin/Interfaces/Models/UserService/GetActiveStatisticResponse';
import GetPaidUsersResponse from '../../../Spirit/Admin/Interfaces/Models/StatisticsService/GetPaidUsersResponse';

export interface UserListRequest {
	Page?: { Skip?: number; Take?: number };
	Search?: string;
	SubscriptionStatus?: 'Free' | 'Active' | 'Expired';
}

export interface UserGoalSurveyItem {
	Id?: string;
	id?: string;
	GoalType?: string;
	goalType?: string;
	Experience?: string;
	experience?: string;
	Skill?: string;
	skill?: string;
	DayTime?: string;
	dayTime?: string;
	FavoriteTypes?: string;
	favoriteTypes?: string;
	Gender?: string;
	gender?: string;
	DateCreated?: Date | string;
	dateCreated?: Date | string;
}

export interface GetUserGoalSurveyResponse {
	UserId?: number;
	userId?: number;
	Items?: UserGoalSurveyItem[];
	items?: UserGoalSurveyItem[];
}

export default class UserService {
	webApiService: WebApiService;
	GetListEvent = new Events<WsResponseModelT<GetPaidUsersResponse>>();
	GetActiveStatisticsEvent = new Events<WsResponseModelT<GetActiveStatisticResponse>>();
	UpdateSubscriptionEvent = new Events<WsResponseModelT<Boolean>>();
	DeleteEvent = new Events<WsResponseModelT<Boolean>>();
	GetSurveyEvent = new Events<WsResponseModelT<GetUserGoalSurveyResponse>>();
	constructor(webApiService: WebApiService) {
		const self = this;
		this.webApiService = webApiService;
		webApiService.on('UserService', 'GetList', (res: WsResponseModelT<GetPaidUsersResponse>) => {
			self.GetListEvent.trigger(res);
		});
		webApiService.on('UserService', 'GetActiveStatistics', (res: WsResponseModelT<GetActiveStatisticResponse>) => {
			self.GetActiveStatisticsEvent.trigger(res);
		});
		webApiService.on('UserService', 'UpdateSubscription', (res: WsResponseModelT<Boolean>) => {
			self.UpdateSubscriptionEvent.trigger(res);
		});
		webApiService.on('UserService', 'Delete', (res: WsResponseModelT<Boolean>) => {
			self.DeleteEvent.trigger(res);
		});
		webApiService.on('UserService', 'GetSurvey', (res: WsResponseModelT<GetUserGoalSurveyResponse>) => {
			self.GetSurveyEvent.trigger(res);
		});
	}
	GetList(request: UserListRequest | FilterRequest = null) { 	
        this.webApiService.send('UserService', 'GetList', {
			Page: (request as any)?.Page || (request as any)?.Pagination || null,
			Search: (request as any)?.Search || null,
			SubscriptionStatus: (request as any)?.SubscriptionStatus || null,
		});
    }
	GetActiveStatistics(request: { DateFrom?: Date | string; DateTo?: Date | string } = null) { 	
        this.webApiService.send('UserService', 'GetActiveStatistics' , request);
    }
	UpdateSubscription(request: { userId: number; premiumExpirationDate: Date | string } = null) {
        this.webApiService.send('UserService', 'UpdateSubscription' , request);
    }
	Delete(userId: number = 0) { 	
        this.webApiService.send('UserService', 'Delete' , { userId });
    }
	GetSurvey(userId: number = 0) {
        this.webApiService.send('UserService', 'GetSurvey' , { userId });
    }
	 // async methods
	async getListAsync(request: UserListRequest | FilterRequest = null): Promise<GetPaidUsersResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.GetList.bind(this), this.GetListEvent)(request);
	}
	async getActiveStatisticsAsync(request: { DateFrom?: Date | string; DateTo?: Date | string } = null): Promise<GetActiveStatisticResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.GetActiveStatistics.bind(this), this.GetActiveStatisticsEvent)(request);
	}
	async updateSubscriptionAsync(request: { userId: number; premiumExpirationDate: Date | string } = null): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.UpdateSubscription.bind(this), this.UpdateSubscriptionEvent)(request);
	}
	async deleteAsync(id: number = 0): Promise<Boolean> {
		return EventToAsyncDecorator.getInstance().bind(this.Delete.bind(this), this.DeleteEvent)(id);
	}
	async getSurveyAsync(userId: number = 0): Promise<GetUserGoalSurveyResponse> {
		return EventToAsyncDecorator.getInstance().bind(this.GetSurvey.bind(this), this.GetSurveyEvent)(userId);
	}
}
